/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { SaleOrder } from 'src/services/saleOrder';
import Badge, { BadgeType } from 'src/components/ui/Badge/Badge';

// export interface OutboundTableProps {
//   containerRef: RefObject<HTMLDivElement>;
//   filterInstance: UseFiltersInterface;
// }
//
// const columnHelper = createColumnHelper<SaleOrder>();
//
// interface ColumnHelperProps {
//   t: (key: string) => string;
//   onTrackingClick: (lines: any[]) => void;
// }
export function OutboundStatusBadge({ status }: { status: SaleOrder['fulfillment_state'] }) {
  const badgeType: Record<string, BadgeType> = {
    entwurf: BadgeType.Neutral2,
    zugestellt: BadgeType.Successful,
    'bereit für versand': BadgeType.Neutral4,
    'teilweise retourniert': BadgeType.Warning,
    'vollständig retourniert': BadgeType.Neutral,
    abgebrochen: BadgeType.Error,
  };

  return (
    <Badge
      className="max-w-min normal-case"
      label={status.label}
      expanded
      colorOverride={status.color ? status.color : ''}
      type={status.color ? '' : badgeType[status.label.toLowerCase()] ?? BadgeType.Neutral}
    />
  );
}
//
// const getColumns = ({ t, onTrackingClick }: ColumnHelperProps) => [
//   columnHelper.accessor(row => row.id, {
//     id: 'checkbox',
//     size: 60,
//     enableHiding: false,
//     enableSorting: false,
//     header: ({ table }) => (
//       <Checkbox
//         checked={table.getIsAllRowsSelected()}
//         indeterminate={table.getIsSomeRowsSelected()}
//         onChange={table.getToggleAllRowsSelectedHandler()}
//       />
//     ),
//     cell: info => (
//       <Checkbox
//         checked={info.row.getIsSelected()}
//         indeterminate={info.row.getIsSomeSelected()}
//         onChange={info.row.getToggleSelectedHandler()}
//       />
//     ),
//   }),
//   columnHelper.accessor(row => row.id, {
//     id: 'id',
//     size: 80,
//     enableHiding: false,
//     meta: {
//       label: t('general.id'),
//     },
//     header: ({ column }) => <span className="typo-text-12 text-faded">{column.columnDef.meta?.label}</span>,
//     cell: info => (
//       <div className="flex flex-col gap-y-4">
//         <span className="typo-text-14--bold text-full"> {info.getValue()} </span>
//         <span className="typo-text-12 text-faded"> {info.row.original.name} </span>
//       </div>
//     ),
//   }),
//   columnHelper.accessor(row => row.partner?.name, {
//     id: 'name',
//     meta: {
//       label: t('general.name'),
//     },
//     header: ({ column }) => <span className="typo-text-12 text-faded">{column.columnDef.meta?.label}</span>,
//     cell: info => (
//       <div className="flex flex-col gap-y-4">
//         <span className="typo-text-14--bold text-full truncate"> {info.getValue()} </span>
//         <span className="typo-text-12 text-faded truncate">
//           {info.row.original.partner?.address.street}
//           <br />
//           {info.row.original.partner?.address.zip_code} {info.row.original.partner?.address.city} |{' '}
//           {info.row.original.partner?.address.country_code}
//         </span>
//       </div>
//     ),
//   }),
//   columnHelper.accessor(row => row.create_date, {
//     id: 'create_date',
//     sortingFn: 'datetime',
//     meta: {
//       label: t('general.order_date'),
//     },
//     header: ({ column }) => <span className="typo-text-12 text-faded">{column.columnDef.meta?.label}</span>,
//     cell: info => {
//       const value = info.getValue();
//       const date = value ? new Date(value) : null;
//       const formattedDate = date?.toLocaleDateString();
//       const formattedTime = date?.toLocaleTimeString();
//
//       return (
//         <div className="flex flex-col gap-y-8">
//           <span className="typo-text-14 text-full">{formattedDate || ''}</span>
//           <span className="typo-text-12 text-faded">{formattedTime || ''}</span>
//         </div>
//       );
//     },
//   }),
//   columnHelper.accessor(row => row.commitment_date, {
//     id: 'commitment_date',
//     sortingFn: 'datetime',
//     meta: {
//       label: t('general.commitment_date'),
//     },
//     header: ({ column }) => <span className="typo-text-12 text-faded">{column.columnDef.meta?.label}</span>,
//     cell: info => {
//       const value = info.getValue();
//       const date = value ? new Date(value) : null;
//       const formattedDate = date?.toLocaleDateString();
//       const formattedTime = date?.toLocaleTimeString();
//
//       return (
//         <div className="flex flex-col gap-y-8">
//           <span className="typo-text-14 text-full">{formattedDate || ''}</span>
//           <span className="typo-text-12 text-faded">{formattedTime || ''}</span>
//         </div>
//       );
//     },
//   }),
//
//   columnHelper.accessor(row => row.carrier?.name, {
//     id: 'carrier_id',
//     size: 80,
//     enableSorting: false,
//     meta: {
//       label: t('general.carrier'),
//     },
//     header: ({ column }) => (
//       <span className="typo-text-12 text-faded w-full text-center">{column.columnDef.meta?.label}</span>
//     ),
//     cell: info => (
//       <span className="typo-text-14 text-full flex justify-center">
//         <Image
//           className={styles.carrier}
//           imageUrl={info.row.original.carrier?.logo_url || ''}
//           alt={info.row.original.carrier?.name || 'carrier-logo'}
//           fallbackComponent={<Icon name="package" width={20} height={20} />}
//         />
//       </span>
//     ),
//   }),
//   columnHelper.accessor(row => (row.carrier as any)?.shipping_lines, {
//     id: 'shipping_lines',
//     size: 120,
//     enableResizing: true,
//     enableSorting: false,
//     meta: {
//       label: t('general.tracking'),
//     },
//     header: ({ column }) => (
//       <span className="typo-text-12 text-faded text-center w-full">{column.columnDef.meta?.label}</span>
//     ),
//     cell: info => {
//       const data = (info.row.original.carrier as any)?.shipping_lines || [];
//
//       return (
//         <span className="typo-text-14 text-full flex justify-center">
//           <Button
//             icon="package"
//             title={(info.row.original?.carrier as any)?.shipping_lines?.length.toString() || '0'}
//             tone={ButtonToneProps.SECONDARY}
//             onClick={() => onTrackingClick(data)}
//           />
//         </span>
//       );
//     },
//   }),
//   columnHelper.accessor(row => row.warehouse?.country_code, {
//     id: 'warehouse_country',
//     size: 120,
//     enableSorting: false,
//     meta: {
//       label: t('general.source_country'),
//     },
//     header: ({ column }) => (
//       <span className="typo-text-12 text-faded w-full text-center">{column.columnDef.meta?.label}</span>
//     ),
//     cell: info => {
//       return (
//         <span className="typo-text-14 text-full flex justify-center">
//           <Button fullOpacity icon={getCountryImageSource(info.getValue())} tone={ButtonToneProps.SECONDARY} />
//         </span>
//       );
//     },
//   }),
//   columnHelper.accessor(row => row.partner?.address.country_code, {
//     id: 'partner_id',
//     size: 120,
//     enableSorting: false,
//     meta: {
//       label: t('general.destination_country'),
//     },
//     header: ({ column }) => (
//       <span className="typo-text-12 text-faded w-full text-center">{column.columnDef.meta?.label}</span>
//     ),
//     cell: info => {
//       const value = info.getValue();
//       const imageSrc = getCountryImageSource(value);
//       return (
//         value &&
//         imageSrc && (
//           <span className="typo-text-14 text-full flex justify-center">
//             <Button fullOpacity icon={getCountryImageSource(value)} tone={ButtonToneProps.SECONDARY} />
//           </span>
//         )
//       );
//     },
//   }),
//   columnHelper.accessor(row => row.order_lines?.length, {
//     id: 'order_lines',
//     size: 120,
//     meta: {
//       label: t('general.products'),
//     },
//     header: ({ column }) => (
//       <span className="typo-text-12 text-faded w-full text-center">{column.columnDef.meta?.label}</span>
//     ),
//     cell: info => {
//       return (
//         <div className="w-full text-center display-inline">
//           <span className="typo-text-14 text-full"> {info.getValue()} </span>
//         </div>
//       );
//     },
//   }),
//   columnHelper.accessor(row => row.amount_total, {
//     id: 'amount_total',
//     size: 80,
//     meta: {
//       label: t('general.amount_total'),
//     },
//     header: ({ column }) => (
//       <span className="typo-text-12 text-faded w-full text-center">{column.columnDef.meta?.label}</span>
//     ),
//     cell: info => (
//       <div className="w-full text-center display-inline">
//         <span className="typo-text-14 text-full"> {info.getValue()} </span>
//       </div>
//     ),
//   }),
//   columnHelper.accessor(row => row.connector, {
//     id: 'connector_id',
//     size: 80,
//     enableSorting: false,
//     meta: {
//       label: t('general.channel'),
//     },
//     header: ({ column }) => (
//       <span className="typo-text-12 text-faded w-full text-center">{column.columnDef.meta?.label}</span>
//     ),
//     cell: info => (
//       <span className="typo-text-14 text-full w-full flex gap-x-6 items-center justify-center">
//         <Image
//           imageUrl={info.getValue() || ''}
//           alt="logo"
//           className="w-[2rem]"
//           fallbackComponent={<Icon name="api" width={20} height={20} />}
//         />
//       </span>
//     ),
//   }),
//   columnHelper.accessor(row => row.fulfillment_state, {
//     id: 'fulfillment_state',
//     meta: {
//       label: t('general.status'),
//     },
//     header: ({ column }) => <span className="typo-text-12 text-faded">{column.columnDef.meta?.label}</span>,
//     cell: info => {
//       return (
//         <div className="flex">
//           <span className="typo-text-14 text-full">
//             <OutboundStatusBadge status={info.getValue()} />
//           </span>
//         </div>
//       );
//     },
//   }),
//   columnHelper.display({
//     id: 'actions',
//     size: 80,
//     enableHiding: false,
//     meta: {
//       label: t('general.actions'),
//     },
//     header: () => <Icon className="text-full opacity-60 flex justify-center w-full" name="edit" />,
//     cell: () => <Icon className="text-full opacity-60 flex justify-center" name="settings" />,
//   }),
// ];

// const OutboundTable: React.FC<OutboundTableProps> = ({ containerRef, filterInstance }) => {
//   const { t } = useTranslation();
//   const rootRef = React.useRef<HTMLDivElement>(null);
//
//   const options = getPaginationOptions();
//   const [isConfirmationOpen, setIsConfirmationOpen] = React.useState(false);
//   const [isOrderConfirmationOpen, setIsOrderConfirmationOpen] = React.useState(false);
//   const [selectedOrderId, setSelectedOrderId] = React.useState<number | null>(null);
//   const [rowSelection, setRowSelection] = React.useState({});
//   // const { mutateAsync: confirmSaleOrders } = useSaleOrderConfirm();
//
//   const [columnVisibility, setColumnVisibility] = React.useState<VisibilityState>({
//     id: true,
//     name: true,
//     create_date: true,
//     commitment_date: false,
//     carrier: true,
//     shipping_lines: true,
//     warehouse_country: true,
//     country_name: true,
//     order_lines: false,
//     amount_total: false,
//     connector: true,
//     df_delivery_status: true,
//     actions: true,
//   });
//   const [showColumnSelect, setShowColumnSelect] = React.useState(false);
//   const [pagination, setPagination] = React.useState<PaginationState>({
//     pageIndex: 0,
//     pageSize: parseInt(options[0].value, 20),
//   });
//
//   const [sorting, setSorting] = React.useState<SortingState>([]);
//   const sort = sorting[0];
//   const { data: saleOrders, isLoading: loading } = useSaleOrdersQuery({
//     page: pagination.pageIndex + 1,
//     size: pagination.pageSize,
//     sort_by: sort ? sort.id : undefined,
//     sort_order: sort && (sort.desc ? 'desc' : 'asc'),
//     domain: filterInstance.domain,
//   });
//
//   const [isTrackingModalOpen, setTrackingModalOpen] = React.useState(false);
//   const [selectedShippingLines, setSelectedShippingLines] = React.useState<any[]>([]);
//
//   const onTrackingClick = (lines: any[]) => {
//     setSelectedShippingLines(lines);
//     setTrackingModalOpen(true);
//   };
//
//   const table = useReactTable({
//     data: (saleOrders?.items as SaleOrder[] | undefined) || [],
//     columns: getColumns({ t, onTrackingClick }),
//     state: {
//       rowSelection,
//       pagination,
//       sorting,
//       columnVisibility,
//     },
//     enableRowSelection: true,
//     enableSorting: true,
//     columnResizeMode: 'onChange',
//     columnResizeDirection: 'ltr',
//     enableColumnResizing: true,
//     onColumnVisibilityChange: setColumnVisibility,
//     onRowSelectionChange: setRowSelection,
//     getFilteredRowModel: getFilteredRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     manualPagination: true,
//     onSortingChange: setSorting,
//     getCoreRowModel: getCoreRowModel(),
//   });
//   const navigate = useNavigate();
//
//   const refresh = () => {
//     setPagination({ ...pagination, pageIndex: 0 });
//   };
//
//   // Handle per page update when user changes the value
//   const handlePerPageUpdate = (selectedOption: SingleValue<Option>) => {
//     if (selectedOption) {
//       setPagination({ pageIndex: 0, pageSize: Number(selectedOption.value) });
//       if (containerRef) {
//         containerRef.current?.scrollIntoView({ behavior: 'smooth' });
//       }
//     }
//   };
//
//   // Handle table pagination click event
//   const handleTablePaginationClick = (direction: 'previous' | 'next') => {
//     const newIndex = direction === 'next' ? pagination.pageIndex + 1 : pagination.pageIndex - 1;
//     setPagination({ ...pagination, pageIndex: newIndex });
//     if (containerRef) {
//       containerRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }
//   };
//
//   const cancelSelectedSaleOrders = async () => {
//     const indexes = Object.keys(rowSelection).map(Number);
//     const selectedSaleOrders = indexes.map(index => saleOrders?.items[index]);
//
//     await selectedSaleOrders.reduce(async promise => {
//       await promise;
//       // return deleteSaleOrderById(Number(saleOrder?.id));
//     }, Promise.resolve());
//     refresh();
//     setRowSelection({});
//   };
//
//   // const onSaleOrderDelete = async () => {
//   //   try {
//   //     // await deleteSaleOrderById(id);
//   //     refresh();
//   //     toast.success(t('success.delete_sale_order_success'));
//   //   } catch (error) {
//   //     toast.error(t('errors.delete_sale_order_failed'));
//   //   }
//   // };
//
//   const onSaleOrderConfirm = async (id: number) => {
//     try {
//       console.error('Not implemented yet', id);
//       // await confirmSaleOrders([id]);
//       refresh();
//       toast.success(t('success.confirm_sale_order_success'));
//     } catch (error) {
//       toast.error(t('errors.confirm_sale_order_failed'));
//     }
//   };
//
//   const handleConfirmDelete = async (confirmed: boolean) => {
//     if (confirmed) {
//       // await onSaleOrderDelete(selectedOrderId as number);
//     }
//     setIsConfirmationOpen(false);
//     setSelectedOrderId(null);
//   };
//
//   const handleConfirmOrderConfirm = async (confirmed: boolean) => {
//     if (confirmed) {
//       await onSaleOrderConfirm(selectedOrderId as number);
//     }
//     setIsOrderConfirmationOpen(false);
//     setSelectedOrderId(null);
//   };
//
//   return (
//     <>
//       <div ref={rootRef} className={classNames(styles.root)}>
//         <div className={styles.columnSelectButton}>
//           {loading && <LoadingSkeleton rounded numberOfItems={1} />}
//           <div style={{ opacity: loading ? 0 : 1 }}>
//             <Button tone={ButtonToneProps.SECONDARY} icon="tune" onClick={() => setShowColumnSelect(true)} />
//           </div>
//           {showColumnSelect && !loading && (
//             <ColumnSelectModal onClose={() => setShowColumnSelect(false)} table={table} />
//           )}
//         </div>
//         {loading && <LoadingSkeleton numberOfItems={10} />}
//         <div style={{ opacity: loading ? 0 : 1 }} className={styles.tableWrapper}>
//           {saleOrders?.items.length && (
//             <table
//               className="w-full"
//               {...{
//                 style: {
//                   width: table.getCenterTotalSize(),
//                 },
//               }}>
//               <thead>
//                 {table.getHeaderGroups().map(headerGroup => (
//                   <tr key={headerGroup.id}>
//                     {headerGroup.headers.map(header => (
//                       <th
//                         {...{
//                           key: header.id,
//                           colSpan: header.colSpan,
//                           style: {
//                             width: header.getSize(),
//                           },
//                         }}>
//                         <div className={styles.headerColumn} onClick={header.column.getToggleSortingHandler()}>
//                           {header.isPlaceholder
//                             ? null
//                             : flexRender(header.column.columnDef.header, header.getContext())}
//                           {{
//                             asc: <Icon name="accordion-arrow-up" />,
//                             desc: <Icon name="accordion-arrow-down" />,
//                           }[header.column.getIsSorted() as string] ?? null}
//                         </div>
//                         <div
//                           {...{
//                             onDoubleClick: () => header.column.resetSize(),
//                             onMouseDown: header.getResizeHandler(),
//                             onTouchStart: header.getResizeHandler(),
//                             className: `resizer ${table.options.columnResizeDirection} ${
//                               header.column.getIsResizing() ? 'isResizing' : ''
//                             }`,
//                             style: {
//                               transform: '',
//                             },
//                           }}>
//                           <div />
//                         </div>
//                       </th>
//                     ))}
//                   </tr>
//                 ))}
//               </thead>
//               <tbody>
//                 {table.getRowModel().rows.map(row => (
//                   <tr key={row.original.id} className={classNames({ [styles.isSelected]: row.getIsSelected() })}>
//                     {row.getVisibleCells().map(cell => {
//                       const { id } = cell.column;
//                       if (id === 'actions') {
//                         return (
//                           <td key={`row-${cell.id}`}>
//                             <ActionMenuButton
//                               menuItems={[
//                                 {
//                                   accessoryItem: 'checkmark',
//                                   label: t('general.confirm_sale_order_title'),
//                                   tone: OptionItemTone.Default,
//                                   onClick: () => {
//                                     setSelectedOrderId(Number(cell.row.original.id));
//                                     setIsOrderConfirmationOpen(true);
//                                   },
//                                   disabled: !cell.row.original.is_editable,
//                                 },
//                                 {
//                                   accessoryItem: 'deleteCircle',
//                                   label: t('general.cancel_sale_order'),
//                                   tone: OptionItemTone.Default,
//                                   onClick: () => {
//                                     setSelectedOrderId(Number(cell.row.original.id));
//                                     setIsConfirmationOpen(true);
//                                   },
//                                   disabled: !cell.row.original.is_cancelable,
//                                 },
//                               ]}
//                             />
//                           </td>
//                         );
//                       }
//                       return (
//                         <td
//                           {...{
//                             key: cell.id,
//                             style: {
//                               width: cell.column.getSize(),
//                             },
//                           }}
//                           onClick={() => {
//                             if (id !== 'checkbox' && id !== 'shipping_lines') {
//                               navigate(`/outbound/${cell.row.original.id}`);
//                             }
//                           }}>
//                           {flexRender(cell.column.columnDef.cell, cell.getContext())}
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//           {!saleOrders?.items ||
//             (saleOrders?.items.length === 0 && (
//               <div className={styles.noResultsFallback}>
//                 <NoResultsFound title={t('general.not_sale_orders_found')} />
//               </div>
//             ))}
//         </div>
//         {saleOrders?.items && saleOrders?.items.length > 0 && (
//           <div className="w-full my-20 flex items-center">
//             <div className="flex gap-x-10 flex-1 items-center">
//               <div>
//                 <Select onChange={handlePerPageUpdate} options={options} defaultValue={options[1]} />
//               </div>
//               <div className="typo-text-12 text-faded">{t('general.per_page')}</div>
//             </div>
//             <div className="ml-auto">
//               <TablePagination
//                 maxPage={saleOrders?.pages || 0}
//                 onPaginationClick={handleTablePaginationClick}
//                 currentPage={pagination.pageIndex}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//       {rowSelection && Object.keys(rowSelection).length > 0 && (
//         <Portal>
//           <div className={styles.quickActionMenu}>
//             <div className={styles.inner}>
//               <Button
//                 title={t('general.cancel_sale_orders')}
//                 tone={ButtonToneProps.SECONDARY}
//                 icon="deleteCircle"
//                 onClick={cancelSelectedSaleOrders}
//               />
//             </div>
//           </div>
//         </Portal>
//       )}
//       <ConfirmationModal
//         isOpen={isConfirmationOpen}
//         title={t('general.cancel_sale_order')}
//         description={t('general.cancel_sale_order_text')}
//         onClose={handleConfirmDelete}
//       />
//       <ConfirmOrderConfirmationModal
//         isOpen={isOrderConfirmationOpen}
//         title={t('general.confirm_sale_order_title')}
//         onClose={handleConfirmOrderConfirm}
//         text={t('general.confirm_sale_order_text')}
//       />
//       <TrackingListModal
//         isOpen={isTrackingModalOpen}
//         onClose={() => setTrackingModalOpen(false)}
//         items={selectedShippingLines}
//       />
//     </>
//   );
// };
//
// export default OutboundTable;
